import GenericPage from '../components/generic/GenericPage'
import tiles from '../components/generic/Tiles'

const MapNP = () => {
  return (
    <GenericPage frame="https://rsgiskaznu.maps.arcgis.com/apps/mapviewer/index.html?webmap=a0b4c6ef979541d18a97368117d8dbb4" title="Карта природоохранных мероприятий" tiles={tiles.back('map')} frame_offset={60}/>
  )
}
export default MapNP
